export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CatalogMenu.vue?vue&type=template&id=26091c5b"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Catalogs/RoadConcepts/CatalogMenu.vue?vue&type=template&id=26091c5b
// module id = 1940
// module chunks = 31